module.exports = __webpack_public_path__ + "static/media/roblox.c3e1ed9e.svg";